import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'VerizonTheme',
  code: 'verizon',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#f9f9f9',
    footerBackground: '#000',
    footerText: '#8c8c8c',
    footerBorder: '#e0e7e9',
    progressBar: '#000',
  },
  logoSize: {
    width: '131px',
    height: '56px',
  },
  baseColors: {
    link: '#000',
    cta: '#000',
    hover: '#000',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const VerizonTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
